import { Network, Cloud, Smartphone, AlertTriangle } from 'lucide-react';
import Card from '@/components/common/ui/Card';

const plans = [
   {
        title: "Network Security",
        description: "Implement advanced network protection measures to prevent unauthorized access and ensure data integrity.",
        icon: Network,
    },
    {
        title: "Cloud Security",
        description:
            "Safeguard your cloud environments with comprehensive security solutions tailored to your business needs.",
        icon: Cloud,
    },
    {
        title: "Endpoint Protection",
        description:
            "Secure all endpoints, including laptops and mobile devices, against malware and other cyber threats.",
        icon: Smartphone,
    },
    {
        title: "Incident Response",
        description:
            "Quickly and effectively respond to security breaches with our expert incident response team.",
        icon: AlertTriangle,
    }
];

export default function OtherServices() {
    return (
        <section className="container pb-24 pt-24">
            <div className="text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-12">
                    Our Cyber Security Services Network Security
                </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}